import { render, staticRenderFns } from "./commentDefault.vue?vue&type=template&id=1f1ac944&scoped=true"
import script from "./commentDefault.vue?vue&type=script&lang=js"
export * from "./commentDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ac944",
  null
  
)

export default component.exports